import { Action, createReducer, on } from '@ngrx/store';
import { IRemoveEmployeeRequest, IRemoveEmployeeResponse } from '../models/remove-user.model';
import { IGenericError, ErrorResponse } from 'src/app/core/models/generic-models';
import { loadRemoveUserRequest, loadRemoveUserSuccess, loadRemoveUserFailure } from '../actions/remove-user.actions';

export const removeUserFeatureKey = 'removeUser';

export interface RemovedState {
  isUserRemovedRequest: IRemoveEmployeeRequest;
  isUserRemovedResponse: IRemoveEmployeeResponse;
  isUserRemovedFailure: IGenericError<ErrorResponse>;
}

export const initialState: RemovedState = {
  isUserRemovedRequest: undefined,
  isUserRemovedResponse: undefined,
  isUserRemovedFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(loadRemoveUserRequest, (state, action) => ({
    ...state,
    isUserRemovedRequest: action.request
  })),
  on(loadRemoveUserSuccess, (state, action) => ({
    ...state,
    isUserRemovedResponse: action.response
  })),
  on(loadRemoveUserFailure, (state, action) => ({
    ...state,
    isUserRemovedFailure: action.error
  }))
);

export const getUserRemovedRequest = (state: RemovedState) => state.isUserRemovedRequest;
export const getUserRemovedResponse = (state: RemovedState) => {
  return state.isUserRemovedResponse;
};
export const getUserRemovedFailure = (state: RemovedState) => state.isUserRemovedFailure;
